var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-popup__content"},[_c('i',{staticClass:"vm--close-button icon-close",on:{"click":_vm.close}}),_c('img',{staticClass:"image-popup__image",attrs:{"src":_vm.imageUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }